import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "88c3c2fd-3d7d-4873-a469-a314cded23e5", content: "Alternative Forced Choice (AFC)", options: {} },
  { id: "603fd21f-258a-465c-881d-530f8cb78125", content: "Category Scaling", options: {} },
  { id: "7219e071-4a5e-4d51-a4c7-112464bf81af", content: "Pairwise Comparison", options: {} },
  {
    id: "b3d96bc9-f480-42cc-978b-d996ff190b6b",
    content: "MUltiple Stimuli with Hidden<br>Reference and Anchor (MUSHRA)",
    options: {},
  },
];

const groups = [
  {
    id: "c70e27f1-514a-4680-915c-4ab7d007be9b",
    content:
      "The participant is presented with a reference stimulus and has to rate the subjective quality of different compression rates.",
    options: {},
  },
  {
    id: "8ac25461-3408-46fe-a50f-be1aafd69f11",
    content:
      "Three stimulus are presented to the participant, one being different than the other two. Aiming to test if a perceivable difference exists.",
    options: {},
  },
  {
    id: "92afa7a4-9d2b-4cd6-9dc0-4ade584e06d5",
    content: "The participant is presented with one stimulus at a time and asked to rate specific attributes of it.",
    options: {},
  },
  {
    id: "dc381254-73d6-4786-bb8c-16beff2ee615",
    content: "Stimuli are presented in couples for the participant to choose a prefered one.",
    options: {},
  },
];

export const task: Task = {
  id: "c64f5994-bbf7-4f45-ab98-ef8c644b02c6",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "c70e27f1-514a-4680-915c-4ab7d007be9b", itemsId: ["b3d96bc9-f480-42cc-978b-d996ff190b6b"] },
    { groupId: "8ac25461-3408-46fe-a50f-be1aafd69f11", itemsId: ["88c3c2fd-3d7d-4873-a469-a314cded23e5"] },
    { groupId: "92afa7a4-9d2b-4cd6-9dc0-4ade584e06d5", itemsId: ["603fd21f-258a-465c-881d-530f8cb78125"] },
    { groupId: "dc381254-73d6-4786-bb8c-16beff2ee615", itemsId: ["7219e071-4a5e-4d51-a4c7-112464bf81af"] },
  ],
};
